/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type { ReactNode } from "react";
import { useEffect, useState } from "react";

import type { ThemeType } from "../../../global/emotion";
import { zIndices } from "../../../global/emotion";
import { useScroll } from "../../hooks/useScroll";
import { Loader } from "../blocks/other/Loader/Loader.emotion";

const divStyle: Interpolation<ThemeType> = (theme) => ({
  alignItems: "center",
  backgroundColor: theme.semanticColors.background,
  display: "flex",
  height: "100vh",
  justifyContent: "center",
  position: "fixed",
  width: "100vw",
  zIndex: zIndices.loading,
});

export type LoadingWrapperProps = { children: ReactNode; isLoading?: boolean };

export const LoadingWrapper = ({
  children,
  isLoading = false,
}: LoadingWrapperProps) => {
  const [isMounted, setIsMounted] = useState(false);

  const { allowScroll, disableScroll } = useScroll();

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!isLoading && isMounted) allowScroll();
    else disableScroll();

    return () => {
      disableScroll();
    };
  }, [isLoading, isMounted]);

  if (isLoading || !isMounted)
    return (
      <div css={divStyle}>
        <Loader />
      </div>
    );

  return children;
};
